import styled, { css } from 'styled-components'

export const SliderContainer = styled.div(
    ({ theme }) => css`
        position: relative;
        max-width: 100%;
        margin-top: ${theme.spacing.xSmall};
    `,
)

export const StyledCarouselProvider = styled.div<{ margin?: string }>`
    width: 100%;
    margin: ${({ margin }) => (margin ? margin : 0)};
    li {
        list-style: none;
    }
    touch-action: pan-y;
`

export const StyledSlider = styled.div`
    overflow: hidden;
`
